import React from "react";
import { RatingText } from "@beacharound/beacharound-ui";
import { getReviewsCounter } from "../../api/reviews";
import { useQuery } from "react-query";

export default function ReviewsPlaceCount({ place }) {

    const { data: reviewsCount } = useQuery(["reviews", "counter", place], () =>
        getReviewsCounter({ params: { reviewed: place } })
    )

    return (
        <RatingText
            rating={reviewsCount?.median}
            ratingsLength={reviewsCount?.count}
        />
    )
}
